import { getApp, getApps, initializeApp } from "firebase/app";

// Shared Firebase configuration for the web client.
const firebaseConfig = {
  apiKey: "AIzaSyDJHy-rY6Q9XNK81GUgz1bIuaf7FBhdk3E",
  authDomain: "members.gcdp.org",
  databaseURL: "https://sign-tracker-3ee19-default-rtdb.firebaseio.com",
  projectId: "sign-tracker-3ee19",
  storageBucket: "sign-tracker-3ee19.appspot.com",
  messagingSenderId: "760389797829",
  appId: "1:760389797829:web:06e59a5b411d6a7b202dac",
  measurementId: "G-PX5FKD9PFT",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export { app, firebaseConfig };